import { render, staticRenderFns } from "./ADownloadIcon.vue?vue&type=template&id=0fbcfce3&scoped=true&"
import script from "./ADownloadIcon.vue?vue&type=script&lang=js&"
export * from "./ADownloadIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fbcfce3",
  null
  
)

export default component.exports